// Paramètres et confidentialité.
//
// ⚛️ ÉCRAN MIGRÉ VERS REACT → js/react/ecrans/Parametres.jsx
// Ce fichier n'est plus qu'un adaptateur pour le routeur de app.js.
// Le changement de mot de passe vit désormais dans parametres-mdp.js, partagé
// par les deux versions.
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Parametres from "../react/ecrans/Parametres.jsx";

export const rendre = vueReact(Parametres);
